import { AspectRatio, Button } from '@mantine/core';
import { ContextModalProps } from '@mantine/modals';
import { useTranslation } from 'react-i18next';

import styles from './VideoTutorialModal.module.scss';

const VideoTutorialModal = ({
  context,
  id,
  innerProps,
}: ContextModalProps<{ videoUrl: string }>) => {
  const { t } = useTranslation();

  const handleClose = () => {
    context.closeModal(id);
  };

  const getEmbedUrl = (url: string) => {
    const videoIdMatch = url.match(
      /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/
    );
    const videoId = videoIdMatch ? videoIdMatch[1] : null;
    return videoId ? `https://www.youtube.com/embed/${videoId}` : url;
  };

  return (
    <>
      <AspectRatio ratio={16 / 9}>
        <iframe
          src={getEmbedUrl(innerProps.videoUrl)}
          title="Lecteur vidéo YouTube"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </AspectRatio>

      <div className={styles.buttons}>
        <Button onClick={handleClose}>{t('common.close', 'Fermer')}</Button>
      </div>
    </>
  );
};

export default VideoTutorialModal;
